module.exports = __webpack_public_path__ + "img/selected5-min.34e7bbd5.png";